module.exports = __webpack_public_path__ + "static/media/textlayer_size.b6732b7e.jpg";